import { yup } from '@jbc-year-end-adj/common/yup';
import { Request, NewOrOldType } from './query';

import { fileSchemaFormat, amountFormat } from '@jbc-year-end-adj/2024/utils/formatter';
import { FileType } from '@jbc-year-end-adj/2024/types';

export type Schema = {
  earthquakeInsurances: EarthquakeInsuranceSchema[];
};

export type EarthquakeInsuranceSchema = {
  id?: string;
  amount: string;
  insuranceDuration: string;
  insuranceType: string;
  name: string;
  nameOfContractor: string;
  nameOfRecipient: string;
  newOrOld: NewOrOldType;
  image: FileType | File | null;
};

const earthquakeInsuranceSchema = (imageRequired: boolean) =>
  yup.object({
    id: yup.string(),
    name: yup
      .string()
      .required()
      .label('保険会社等の名称'),
    insuranceType: yup
      .string()
      .required()
      .label('保険等の種類（目的）'),
    insuranceDuration: yup
      .string()
      .required()
      .label('保険期間'),
    nameOfContractor: yup
      .string()
      .required()
      .label('保険等の契約者の氏名'),
    nameOfRecipient: yup
      .string()
      .required()
      .label('保険等の受取人 氏名'),
    newOrOld: yup
      .mixed<NewOrOldType>()
      .required()
      .label('保険料区分'),
    amount: yup
      .string()
      .required()
      .positiveAmountFormat()
      .label('保険料金額'),
    image: imageRequired
      ? yup
          .mixed<FileType | File>()
          .fileSize()
          .required()
          .label('証明書画像')
      : yup
          .mixed<FileType | File>()
          .fileSize()
          .nullable()
          .label('証明書画像')
  });

export const schema = (imageRequired: boolean) =>
  yup.object({
    earthquakeInsurances: yup.array().of(earthquakeInsuranceSchema(imageRequired))
  });

export const generateDefaultValues = (profile: Request['profile']): Schema => {
  return {
    earthquakeInsurances: profile.earthquakeInsurances.map(insurance => ({
      id: String(insurance.id),
      amount: amountFormat(insurance.amount),
      insuranceDuration: insurance.insuranceDuration,
      insuranceType: insurance.insuranceType,
      name: insurance.name,
      nameOfContractor: insurance.nameOfContractor,
      nameOfRecipient: insurance.nameOfRecipient,
      newOrOld: insurance.newOrOld,
      image: fileSchemaFormat(insurance.image)
    }))
  };
};

export const earthquakeInsuranceObj: EarthquakeInsuranceSchema = {
  amount: '',
  insuranceDuration: '',
  insuranceType: '',
  name: '',
  nameOfContractor: '',
  nameOfRecipient: '',
  newOrOld: 'new_type',
  image: null
};
